import { AUDIO_QUALITY_INTERVAL_MS, AUDIO_QUALITY_MAX_REPORTS, audioMetricSnapshot,
  LOCAL_AUDIO_METRICS, REMOTE_AUDIO_METRICS } from "../lib/rtc-audio-diagnostics.mjs";

function safely(read) { try { return read(); } catch { return null; } }
export function collectAudioQuality({ client, platform, elapsedSeconds, visibility, micEnabled, audioContext, autoplayBlocked }) {
  const context = ["running", "suspended", "interrupted", "closed"].includes(audioContext) ? audioContext : "unknown";
  return { version: 1, platform: ["ios_webview", "android_webview"].includes(platform) ? platform : "other",
    elapsedSeconds: Number.isFinite(elapsedSeconds) ? Math.max(0, Math.min(86_400, Math.floor(elapsedSeconds))) : 0,
    visibility: visibility === "hidden" ? "hidden" : "visible", micEnabled: Boolean(micEnabled),
    audioContext: context, autoplayBlocked: Boolean(autoplayBlocked),
    local: audioMetricSnapshot(safely(() => client.getLocalAudioStats()), LOCAL_AUDIO_METRICS),
    remote: (client?.remoteUsers || []).filter(user => user.audioTrack).slice(0, 2).map(user => ({
      playing: typeof user.audioTrack.isPlaying === "boolean" ? user.audioTrack.isPlaying : null,
      metrics: audioMetricSnapshot(safely(() => user.audioTrack.getStats()), REMOTE_AUDIO_METRICS)
    })) };
}

export function createAudioQualityReporter({ read, send, schedule = setInterval, cancel = clearInterval }) {
  let timer = null, controller = null, generation = 0, reports = 0, active = false;
  async function sample(expectedGeneration) {
    if (!active || expectedGeneration !== generation || controller || reports >= AUDIO_QUALITY_MAX_REPORTS) return;
    const current = generation, request = new AbortController();
    controller = request;
    try {
      const value = read();
      if (!value) return;
      reports += 1;
      await send(value, request.signal);
    } catch { /* Diagnostic failure must not affect media or trigger retries. */ }
    finally { if (current === generation) controller = null; }
  }
  function stop() {
    active = false; generation += 1;
    if (timer !== null) cancel(timer);
    timer = null; controller?.abort(); controller = null;
  }
  return { start() {
    stop(); reports = 0; active = true;
    const current = generation;
    timer = schedule(() => void sample(current), AUDIO_QUALITY_INTERVAL_MS); void sample(current);
  }, stop };
}
